import { Typography } from "@mui/material";
import React from "react";
import Lottie from "react-lottie";
import animationData from "assets/images/fail_error.json";


const defaultOptions = {
  loop: true,
  autoplay: true,
  animationData: animationData,
  rendererSettings: {
    preserveAspectRatio: "xMidYMid slice",
  },
};

const FailIcon = () => {
  return (
    <div>
      <Lottie options={defaultOptions} height={'100px'} width={'100px'} />
    </div>
  );
};

export default FailIcon;
